<template>
  <v-btn
    depressed
    dark
    :color="colors"
    outlined
    :large="size"
    :class="{'btn-wide': wide}"
    @click="handleClick"
  >
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  props: {
    min: {
      type: Boolean,
      default: false
    },
    red: {
      type: Boolean,
      default: false
    },
    wide: {
      type: Boolean,
      default: false
    },
    disabledBtn: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    // `large`に応じてクラスを動的に生成する
    size () {
      return !this.min
    },
    colors () {
      const color = this.disabledBtn ? '#c8c8c8' : (this.red ? '#E62233' : '#0F9956')
      return color
    }
  },
  methods: {
    // `click`イベントを発行
    handleClick (ev) {
      this.$emit('click', ev)
    }
  }
}
</script>

<style scoped>
button.btn-wide {
  width: 100%;
}
</style>
